// -- Endpoints --

// Countries
export const GET_COUNTRIES = 'api/countries';

export default GET_COUNTRIES;
